
import BaseComponent from "../../shared/baseComponent";
import FileConfigServices from "../../services/domainServices/fileConfigServices";
import { hasFunctionalPermission } from "../../utils/AuthorizeNavigation/authorizeNavigation";
import { securityKey } from "../../navigation/SecurityKey";

export default class FileConfig extends BaseComponent {
  constructor(props) {
    super(props);


    this.fileConfigServices = new FileConfigServices();
    this.state = {
      ...this.state,
      loading: true,
      setIsLoad: false,
      setModuleList: [],
      isShowUpdateBtn: true,
    };
    this.fileConfigServices.onUpdateState = this.updateState.bind(this);
  }

  componentDidMount() {

    this.fileConfigServices.onGetAllModuleNameList();
    this.state.isShowUpdateBtn = hasFunctionalPermission(securityKey.SAVEFILECONFIG);
  }


  handleInputChange = (index, value) => {
    if (value.length <= 3) {
      const updatedModuleList = [...this.state.setModuleList];
      updatedModuleList[index].fileDeleteEligibiltyAfterDays = parseInt(value);

      this.setState({ setModuleList: updatedModuleList });
    }
  };
  onUpdate() {
    
    this.fileConfigServices.onUpdateFileDeleteEligibiltyAfterDaysByModuleType(this.state.setModuleList);
  }

  render() {
    return (
      <>
        {this.state.isShowUpdateBtn?.hasAccess && (
          <div className="addnewuser-button mb-2">
            <button className="tab-title tab-title--active  btn-hover  color-3 active" onClick={() => { this.onUpdate() }}>Save</button>

          </div>)
        }

        <div className="file-manager-table">
          <div className="table-responsive text-nowrap text-shadow-pd table-container">
            <table className="table table-shadow rpa_table bg-white table-fixed">
              <thead>
                <tr>

                  <th className="font-semibold text-left w-50">Module Name</th>
                  <th className="font-semibold text-left w-30"> File Delete Eligibilty After Days</th>
                </tr>
              </thead>
              {this.state.setModuleList.length === 0 ?
                <div className="d-flex justify-content-center p-3 font-size-16"> No Records Found</div>
                :
                <>
                  <tbody className="table-border-bottom-0">
                    {this.state.setModuleList.map((item, index) => (
                      <tr key={index} >
                        <td className="text-left w-50">{item.moduleName}</td>
                        <td className="text-left w-30">
                          <input

                            className="form-control config-input-text"
                            type="text"
                            name="currentPage"
                            onChange={(event) => this.handleInputChange(index, event.target.value)}
                            value={item.fileDeleteEligibiltyAfterDays || 0}
                          />

                        </td>




                      </tr>
                    ))}
                  </tbody>
                </>
              }

            </table>
          </div>
        </div>
        {/* )} */}


      </>
    );
  }
}